import { Variant } from '@kizi/core-components';

const _default: Variant = {
  '&[type], &:not([type])': {
    bg: 'background',
    border: '1px solid',
    borderColor: 'second.1',
    borderRadius: 1,
    color: 'text',
    fontFamily: 'body',
    fontSize: 3,
    outline: 'none',
    padding: 3,
    width: '100%',
    height: 54,
    '&:focus': {
      border: '2px solid',
      borderColor: 'main.1',
    },
    '&::placeholder': {
      color: 'placeholder',
    },
    '> svg': { fill: 'placeholder' },
  },
};

const radioMain: Variant = {
  fontSize: 2,
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: 'second.0',
  mr: 2,
  '& input:checked ~ span': {
    bg: 'main.1',
    m: '0',
    width: '10px',
    height: '10px',
  },
  '&:hover': {
    bg: 'white',
    borderColor: 'main.1',
  },
  '&:focused': {
    borderColor: 'main.1',
  },
  checked: {
    borderColor: 'main.1',
    borderStyle: 'solid',
    borderWidth: '2px',
    mr: 2,
    '& input:checked ~ span': {
      bg: 'main.1',
      m: '0',
      width: '10px',
      height: '10px',
      left: 'unset',
      position: 'absolute',
    },
    '&:hover': {
      bg: 'white',
      borderColor: 'main.1',
    },
    '&:focused': {
      borderColor: 'main.1',
    },
  },
};

const radios = {
  main: radioMain,
  success: radioMain,
  error: radioMain,
};

const error: Variant = {
  ..._default,
  borderColor: 'error',
};

const success: Variant = {
  ..._default,
};

const checkboxMain: Variant = {
  fontSize: 2,
  border: '1px solid',
  borderColor: 'second.0',
  borderRadius: 1,
  '&:hover': {
    borderColor: 'main.1',
  },
  checked: {
    fontSize: 2,
    border: '1px solid',
    borderColor: 'main.1',
    borderRadius: 1,
    '& input ~ span': {
      borderRadius: '2px',
    },
    '& input:checked ~ span svg': {
      fill: 'white',
    },
    '& input:checked ~ span': {
      bg: 'main.1',
    },
  },
  disabled: {
    fontSize: 2,
    border: '1px solid',
    borderColor: 'second.1',
    borderRadius: 1,
    '& input ~ span': {
      borderRadius: '2px',
    },
    '& input:checked ~ span svg': {
      fill: 'second.1',
    },
    background: '#F2F2F0',
  },
};

const rangeSliderInput: Variant = {
  '&::-webkit-slider-thumb': {
    WebkitAppearance: 'none',
    position: 'relative',
    width: '22px',
    height: '22px',
    backgroundColor: 'background',
    border: '2px solid',
    borderColor: 'main.1',
    borderRadius: '50%',
    cursor: 'pointer',
    mt: '3px',
    pointerEvents: 'all',
    zIndex: 1,
  },
  '&::-moz-range-thumb': {
    WebkitAppearance: 'none',
    position: 'relative',
    width: '22px',
    height: '22px',
    backgroundColor: 'background',
    border: '2px solid',
    borderColor: 'main.1',
    borderRadius: '50%',
    cursor: 'pointer',
    mt: '3px',
    pointerEvents: 'all',
    zIndex: 1,
  },
  WebkitAppearance: 'none',
  position: 'absolute',
  width: '240px',
  height: '0',
  pointerEvents: 'none',
  outline: 'none',
};

const checkboxes = {
  main: checkboxMain,
  success: checkboxMain,
  error: checkboxMain,
};

const comparisonInput = {
  minWidth: '300px',
  bg: 'background',
  color: 'text',
  fontFamily: 'body',
  fontSize: 3,
  outline: 'none',
  height: 25,
  border: 'none',
  '&:focus': {
    border: '1px',
    borderBottomColor: 'second.0',
    borderBottomStyle: 'dashed',
  },
  '&::placeholder': {
    color: 'main.1',
    maxWidth: 'none',
    fontFamily: 'body',
    fontSize: [2, 3],
    lineHeight: 2,
    fontWeight: 0,
  },
  '&:focus::-webkit-input-placeholder': {
    color: 'second.0',
  },
};

const inputVariants = {
  _default,
  radios,
  error,
  success,
  checkboxes,
  rangeSliderInput,
  comparisonInput,
};

export default inputVariants;
